export default {
  methods: {
    hasRouteParameter (name) {
      return name in this.$route.params
    },

    getRouteParameter (name, isOptional = false) {
      if (name in this.$route.params) {
        return this.$route.params[name]
      }

      if (!isOptional) {
        throw new Error(`Missing route parameter: ${name}`)
      }
    }
  }
}
